import { render, staticRenderFns } from "./Compensation.vue?vue&type=template&id=9ab9c8c0"
import script from "./Compensation.vue?vue&type=script&lang=js"
export * from "./Compensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports